import { createEnvelopeSource } from './create-envelope-source';

/**
 * The game-engagement-rpp KPI source. Pure config over the standardized envelope
 * (`GET /analytics/game-engagement-rpp`): `gameSessionsOpened` / `gamesPlayed` are
 * scalar, `avgPlaysPerUser` / `gameCompletionRate` / `gameDropOffRate` are
 * ratios. All mapping and fetching lives in `createEnvelopeSource`.
 */
export const gameEngagementRppSource = createEnvelopeSource({
    label: 'Game engagement',
    endpoint: 'analytics/game-engagement-rpp',
    metrics: [
        { id: 'gameSessionsOpened', label: 'Opened sessions', type: 'scalar' },
        { id: 'gamesPlayed', label: 'Games played', type: 'scalar' },
        // A ratio: an average carried as games-over-players, so a period with
        // no players reads unavailable rather than "0 plays each".
        { id: 'avgPlaysPerUser', label: 'Avg plays per user', type: 'ratio' },
        { id: 'gameCompletionRate', label: 'Completion rate', type: 'ratio' },
        { id: 'gameDropOffRate', label: 'Drop-off rate', type: 'ratio' },
    ],
    forms: ['number', 'rate', 'columns'],
    regionGrain: 'province',
});
